import { Api } from '@axiom/ui';
import type { Notification, NotificationSearch, User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class NotificationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readNotifications(id: User['id']) {
    return super.read<NotificationSearch>({
      endpoint: `/users/${id}/notifications`,
      method: 'GET',
    });
  }

  async updateNotification(
    id: Notification['id'],
    notification: Partial<Notification>
  ) {
    return super.write<{ data: Notification }>({
      endpoint: `/notifications/${id}`,
      body: notification,
      method: 'PATCH',
    });
  }

  async updateNotificationsMarkAllAsRead(id: User['id']) {
    return super.write<{ data: never }>({
      endpoint: `/users/${id}/notifications/markAllAsRead`,
      method: 'PUT',
    });
  }

  async refreshNotifications(id: User['id']) {
    return super.invalidate(`/users/${id}/notifications`, true);
  }
}

export const NotificationsApi = new NotificationsApiClass();
